import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment-timezone";

@Pipe({
  name: "moment",
})
export class MomentPipe implements PipeTransform {
  transform(value: string | undefined | null, format: string): string {
    if (value === undefined || value === null) {
      return "-";
    }

    return moment.tz(value, "Europe/Berlin").format(format);
  }
}
